// extracted by mini-css-extract-plugin
module.exports = {"main-content":"myAds_main-content__dNxf5","search-container":"myAds_search-container__8MFlm","ads-layout":"myAds_ads-layout__6sZz0","empty":"myAds_empty__q3F__"};